import { flattenObject } from '../utils/flatten-object.mjs';
import { BaseEvent } from './base-event.mjs';
import { MAX_EXT_ATTRIBUTES } from '../utils/consts.mjs';

// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
class CustomEvent extends BaseEvent {
    /**
     * A class that extends from {@link BaseEvent} and has all the required functionality to send a VIEW event
     * @param args - Unified object containing the required properties
     */
    constructor(args) {
        const { channel, currency, pointOfSale, language, page, ...rest } = args.eventData;
        super({ channel, currency, language, page, pointOfSale }, args.settings, args.id, args.infer);
        this.extensionData = {};
        this.eventApiClient = args.eventApiClient;
        this.customEventPayload = {
            type: args.type,
            ...rest,
        };
        if (args.extensionData)
            this.extensionData = flattenObject({ object: args.extensionData });
        const numberOfExtensionDataProperties = Object.entries(this.extensionData).length;
        if (numberOfExtensionDataProperties > MAX_EXT_ATTRIBUTES)
            throw new Error(`[IV-0005] This event supports maximum ${MAX_EXT_ATTRIBUTES} attributes. Reduce the number of attributes.`);
        if (numberOfExtensionDataProperties > 0)
            this.customEventPayload.ext = this.extensionData;
    }
    /**
     * Sends the event to Sitecore CDP
     * @returns - A promise that resolves with either the Sitecore CDP response object or null
     */
    async send() {
        const baseAttr = this.mapBaseEventPayload();
        const fetchBody = Object.assign({}, this.customEventPayload, baseAttr);
        return await this.eventApiClient.send(fetchBody);
    }
}

export { CustomEvent };
